import axios from '../../axios'

export default {
  getDepartments: function () {
    return axios.get('departments?all=true')
  }
}



// WEBPACK FOOTER //
// ./src/services/api/DepartmentsApi.js